<template>
  <div>
    <div class="headerNav">
      <div class="headerNavYinShiLogo">
        <router-link to='/homePage'>
          <img src="../assets/img/homePage/gongsi_logo.png" alt="" />
        </router-link>
      </div>
      <div class="headerNavPhoneEmail">
        <div class="navPhone">
          <img src="../assets/img/homePage/dingbu_dianhua.png" alt="" />
          <span>86 (021)-36511001</span>
        </div>
        <div>
          <img src="../assets/img/homePage/dingbu_youxiang.png" class="dingbu_youxiang" alt="" />
          <span>2629387311@qq.com</span>
        </div>
      </div>
    </div>
    <!--       
      :default-active="activeIndex2"
      @select="handleSelect"
    -->
      <!-- <el-menu-item index="/dynamicNews/companyNews">行业新闻</el-menu-item> -->
    <!-- <el-menu
      class="el-menu-demo"
      mode="horizontal"
      :background-color="this.$store.state.navBackground"
      text-color="#fff"
      active-text-color="#ffd04b"
      router
      :default-active="this.$store.state.currentRouter"
      style="border-bottom:1px solid transparent"
    >
      <el-menu-item index="/homePage">首页</el-menu-item>
      <el-menu-item index="/companyProfile">关于我们</el-menu-item> 
      <el-submenu index="3">
        <template slot="title">产业链</template>
        <el-menu-item index="/industrialChain/serviceContent   ">店铺运营</el-menu-item>
        <el-menu-item index="/industrialChain/digitalMarketing">数字营销</el-menu-item>
        <el-menu-item index="/industrialChain/ITSolutions      ">IT解决方案</el-menu-item>
      </el-submenu>
      <el-menu-item index="/softwareProduct"><a>软件产品</a></el-menu-item>
      <el-submenu index="5">
        <template slot="title">新闻动态</template>
        <el-menu-item index="/dynamicNews/companyNews">公司新闻</el-menu-item>
      </el-submenu>
      <el-menu-item index="/jobOpportunities"><a>工作机会</a></el-menu-item>
      <el-menu-item index="/contactUs"><a>联系我们</a></el-menu-item>
    </el-menu> -->
    <div class="nav" :style="{background:this.$store.state.navBackground}">
        <div  class="oneClassTitle"   @click="navClick('首页','/homePage')" :class="navIndex == '/homePage' ? 'homePage':''">
            首页
        </div>
        <div class="oneClassTitle oneClassTitleTwo" @click="navClick('关于我们','/companyProfile')" :class="navIndex == '/companyProfile' ? 'clickBorder':''">
            关于我们
        </div>
        <div 
          class="oneClassTitle oneClassTitleTwo" 
          @mouseover="twoDisplay('industrialChain')" 
          @mouseout="towTitleHide('industrialChain')"
          :class="(navIndex == '/industrialChain/serviceContent' || navIndex == '/industrialChain/digitalMarketing' || navIndex == '/industrialChain/ITSolutions') ? 'clickBorder':''"
          >
            产业链
        </div>
        <div 
          class="oneClassTitle oneClassTitleTwo" 
          @mouseover="twoDisplay('softwareProduct')" 
          @mouseout="towTitleHide('softwareProduct')"
          :class="(navIndex == '/softwareProduct/software' || navIndex == '/softwareProduct/pricePage') ? 'clickBorder':''"
          >
          软件产品
        </div>
        <!-- <div class="oneClassTitle oneClassTitleTwo" @click="navClick('软件产品','/softwareProduct')" :class="navIndex == '/softwareProduct' ? 'clickBorder':''">
            软件产品
        </div> -->
        <div class="oneClassTitle oneClassTitleTwo" @mouseover="twoDisplay('dynamicNews')" @mouseout="towTitleHide('dynamicNews')" :class="navIndex == '/dynamicNews/companyNews' ? 'clickBorder':''">
            新闻动态
        </div>
        <div class="oneClassTitle oneClassTitleTwo" @click="navClick('工作机会','/jobOpportunities')" :class="navIndex == '/jobOpportunities' ? 'clickBorder':''">
            工作机会
        </div>
        <div class="oneClassTitle oneClassTitleTwo" @click="navClick('联系我们','/contactUs')" :class="navIndex == '/contactUs' ? 'clickBorder':''">
            联系我们
        </div>
    </div>
    <div class="twoNav industrialChain" @mouseover="twoDisplay('industrialChain')" @mouseout="towTitleHide('industrialChain')">
      <div class="twoNavDiv">
        <div @click="navClick('店铺运营','/industrialChain/serviceContent')" :class="navIndex == '/industrialChain/serviceContent' ? 'clickColor':''">店铺运营</div>
        <div @click="navClick('数字营销','/industrialChain/digitalMarketing')" :class="navIndex == '/industrialChain/digitalMarketing' ? 'clickColor':''">数字营销</div>
        <div @click="navClick('IT解决方案','/industrialChain/ITSolutions')" :class="navIndex == '/industrialChain/ITSolutions' ? 'clickColor':''">IT解决方案</div>
      </div>
    </div>
    <div class="twoNav softwareProduct" @mouseover="twoDisplay('softwareProduct')" @mouseout="towTitleHide('softwareProduct')">
      <div class="twoNavDiv">
        <div @click="navClick('产品','/softwareProduct/software')" :class="navIndex == '/softwareProduct/software' ? 'clickColor':''">产品</div>
        <div @click="navClick('价格','/softwareProduct/pricePage')" :class="navIndex == '/softwareProduct/pricePage' ? 'clickColor':''">价格</div>
      </div>
    </div>
    <div class="twoNav dynamicNews" @mouseover="twoDisplay('dynamicNews')" @mouseout="towTitleHide('dynamicNews')">
      <div class="twoNavDiv">
        <div @click="navClick('公司新闻','/dynamicNews/companyNews')" :class="navIndex == '/dynamicNews/companyNews' ? 'clickColor':''">公司新闻</div>
      </div>
    </div>

  </div>
</template>

<script>
// import store from "@/store";
export default {
  name: "YinshiOffcialwebsiteHeader",
  data() {
    return {
      navIndex:'/homePage', //当前点击的菜单
    };
  },
  mounted() {},
  computed:{
    currentRouter(){
      return this.$store.state.currentRouter
    }
  },
  watch:{
    currentRouter:function(newval){
      this.navIndex = newval
    }
  },
  methods: {
    // 菜单点击
    navClick(name,router){
      // 保存当前选中的菜单
      this.navIndex = router
      // 路由
      if(this.$route.path == router){
        return
      }else{
        this.$router.push(router)
      }
    },
    // 显示二级菜单
    twoDisplay(clas){
      document.getElementsByClassName(clas)[0].classList.add('twoNavClass')
    },
    // 隐藏二级菜单
    towTitleHide(clas){
      document.getElementsByClassName(clas)[0].classList.remove('twoNavClass')
    }
  },
  created(){
    this.$store.state.currentRouter = this.$route.path  //获取当前页面路由
    this.navIndex = this.$route.path
  }
};
</script>
<style lang="scss">
  .el-menu-item:hover,.el-submenu__title:hover{
    color: rgb(255, 208, 75) !important;
    background: #686fbb70 !important;
  }
</style>
<style lang="scss" scoped>
// 头部 logo和电话及邮箱
.headerNav {
  //整个div
  padding: 18px 270px;
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 999;
  background: #fff;
    //logo
  .headerNavYinShiLogo {
    img {
      width: 167px;
      height: 45px;
    }
  }
  //电话及邮箱
  .headerNavPhoneEmail {
    display: flex;
    div {
      display: flex;
      align-items: center;
      margin-top: -5px;
      img {
        width: 15px; 
        height: 15px; 
        margin-top: 8px; 
        padding: 0px 5px;
      }
      .dingbu_youxiang{
        width: 17px !important; 
      }
      span {
        height: 13px;
        font-size: 16px;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
        font-weight: 400;
        text-align: center;
        color: #444444;
      }
    }
    .navPhone {
      margin-right: 55px;
    }
  }
}
// 导航栏
.el-menu-demo {
  padding: 0px 123px;
  display: flex;
  justify-content: space-between;
}
// 导航栏
.nav{
  padding: 0px 270px;
  display: flex;
  justify-content: space-between;
  z-index: 999;
  position: relative;
  // background: red !important;
  // 一级标题
  .oneClassTitle{
    padding:30px 0px;
    font-size: 18px;
    font-family: Microsoft YaHei, Microsoft YaHei-Bold;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
    cursor: pointer;
    transition: .6s;
    position: relative;
  }
  .oneClassTitle:hover{
    color: #45FFF4;
  }
  // 一级标题 下边框
  .oneClassTitleTwo::before {
    content:'';
    width: 0px;
    height: 2px;
    background: transparent;
    position: absolute;
    bottom: 0px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 999;
    transition: .3s;
  }
  .oneClassTitleTwo:hover::before{
    width: 35px;
    background: #45FFF4;
  } 

  // 选中之后的样式
  .clickBorder{
    color: #45FFF4;
  }
  .clickBorder::before {
    content:'';
    width: 35px;
    height: 2px;
    background: #45FFF4;
    position: absolute;
    bottom: 0px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 999;
    transition: .3s;
  }
  // 首页单独的样式
  .homePage{
    color: #45FFF4;
  }
}
// 二级菜单
.twoNav{
  position:absolute;
  background: hsl(0deg 0% 77.73% / 35.3%);
  width: 100%;
  margin-top: -125px;
  opacity: 0;
  transition: .12s;
  // transition: .5s;
  z-index: 99;
  .twoNavDiv{
    width: 100px;
    text-align: center;
    div{
      white-space: nowrap;
      padding:10px 0;
      font-size: 16px;
      cursor: pointer;
      transition: .2s;
      color: #051429;
      font-weight: 400;
    }
    div:hover{
      color:#C6E8FF;
    }
  }
}
// 产业链  二级菜单
.industrialChain .twoNavDiv{
  margin-left: 34.6%;
}
.softwareProduct .twoNavDiv{
  margin-left: 46%;
}
// 公司新闻
.dynamicNews .twoNavDiv{
  margin-left: 57.8%;
}
// 二级菜单
.twoNavClass{
  margin-top: 0px !important;
  opacity: 1 !important;
}
// 选中之后二级菜单字体颜色
.clickColor{
  color:#C6E8FF !important;
}
</style>
